import React, { useState,useContext,useEffect } from "react";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {Modal,Button} from "react-bootstrap"
import axios from "axios"
import PropTypes from "prop-types";
import ProgressBar from "react-bootstrap/ProgressBar";
import "bootstrap/dist/css/bootstrap.min.css";
import {UserContext} from "../Context/UserContext"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { base_url } from "../../globalConstants";


const propTypes = {
  percent: PropTypes.number.isRequired,
};

export default function FileUpload() {
  
  const [EzzIdd,setEzzIdd]=useState('');
  const [image, setImage] = useState({upload_location:"",raw:""});
  const [modalShow, setModalShow] = React.useState(false);
  const [Prog,setProg]=useState(0);

  const notify = () => toast("Wow so easy !");
  const handleChange = e => {
    if (e.target.files.length) {
      setImage({
        upload_location: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0]
      });
    }
  };

  
  const handleUpload = async e => {
    e.preventDefault();
    console.log(EzzIdd);
    
    const formData = new FormData();
    formData.append("upload_file", image.raw);
    formData.append("ezz_id", EzzIdd);
console.log(image.raw)
    await axios.post(base_url + "invoices/",formData, {
      
      headers: {
        "Content-Type": "multipart/formData"
      },

   
      
      
    }).then(res => {
      console.log(res.data);
      const PercentBar = ({ percent, ...props }) => (
        // spread extra props first to prohibit overriding prop values
        <ProgressBar {...props} now={percent} min={0} max={100} />
      );
      setImage({upload_location:"", raw:""});
      toast("File Uploaded Successfully");
    setModalShow(true);
    
  })
    .catch(err => console.log(err))
  };

 useEffect(()=>{
  setEzzIdd(localStorage.getItem('ezzyid'));
  console.log(EzzIdd);
 },[])

  return (
    <div>
      <label htmlFor="upload-button">
        {image.upload_location ? (
          <img src={image.upload_location} alt="dummy" width="300" height="300" />
        ) : (
          <>
            <span className="fa-stack fa-2x mt-3 mb-2">
              <i className="fas fa-circle fa-stack-2x" />
              <i className="fas fa-store fa-stack-1x fa-inverse" />
            </span>
            <h5 className="text-left" 
              style={{paddingTop:"10px", backgroundColor:"white",paddingBottom:"10px"
              ,paddingLeft:"5px",paddingRight:"5px", 
              borderColor:"slategray", border:"solid",borderRadius:"10px", width:"400px", height:"70px", marginLeft:"45%"}}>
            Upload Invoice</h5>
          </>
        )}
      </label>
      <input
        type="file"
        id="upload-button"
        style={{ display: "none" }}
        onChange={handleChange}
      />
      <br />
      <button style={{paddingRight:"20px"
      , paddingLeft:"20px"
      , paddingTop:"10px", paddingBottom:"10px", 
      backgroundColor:"skyblue", color:"darkblue", border:"solid"
      , borderRadius:"15px", width:"120px", height:"50px", 
      fontSize:"20px", float:"right", marginRight:"54%"}} onClick={handleUpload}>Upload</button>

      <ToastContainer />

  

    </div>
  );
}